"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const aspectRatio = require("aspect-ratio");
function calculateRatio(dimensions) {
    if (dimensions.widthFormat === 'px' &&
        dimensions.heightFormat === 'px' &&
        dimensions.widthValue !== undefined &&
        dimensions.heightValue !== undefined &&
        dimensions.widthValue > 0 &&
        dimensions.heightValue > 0) {
        return aspectRatio(dimensions.widthValue, dimensions.heightValue);
    }
    return undefined;
}
exports.calculateRatio = calculateRatio;
//# sourceMappingURL=calculate-ratio.js.map